module.exports = __webpack_public_path__ + "static/media/surfer2.e29bfb6a.gif";